import { EventFilterView, EventViewPrefilter, FilterCategory } from "../../../types";

const afterShotInsidePaFlags = new Map<string, string>([
	["true", "event.v3.flag.global.true"],
	["false", "event.v3.flag.global.false"],
]);

const assistFlags = new Map<string, string>([
	["true", "event.v3.flag.global.true"],
	["false", "event.v3.flag.global.false"],
]);

const blockTypeFlags = new Map<string, string>([
	["after_shot", "event.v3.flag.block_type.after_shot"],
	["after_pass", "event.v3.flag.block_type.after_pass"],
]);

const bodyPartFlags = new Map<string, string>([
	["left-foot", "event.v3.flag.body_part.left_foot"],
	["right-foot", "event.v3.flag.body_part.right_foot"],
	["head", "event.v3.flag.body_part.head"],
	["other", "event.v3.flag.body_part.other"],
]);

const bodyPartGoalKeeperFlags = new Map<string, string>([
	["hand", "event.v3.flag.body_part.hand"],
	["left-foot", "event.v3.flag.body_part.left_foot"],
	["right-foot", "event.v3.flag.body_part.right_foot"],
	["head", "event.v3.flag.body_part.head"],
	["other", "event.v3.flag.body_part.other"],
]);

const cardTypeFlags = new Map<string, string>([
	["yellow", "event.v3.flag.card_type.yellow"],
	["red", "event.v3.flag.card_type.red"],
]);

const crossFlags = new Map<string, string>([
	["true", "event.v3.flag.global.true"],
	["false", "event.v3.flag.global.false"],
]);

const directionFlags = new Map<string, string>([
	["forward", "event.v3.flag.direction.forward"],
	["backward", "event.v3.flag.direction.backward"],
	["sideways", "event.v3.flag.direction.sideways"],
]);

const divingSaveFlags = new Map<string, string>([
	["true", "event.v3.flag.global.true"],
	["false", "event.v3.flag.global.false"],
]);

const footFlags = new Map<string, string>([
	["left-foot", "event.v3.flag.body_part.left_foot"],
	["right-foot", "event.v3.flag.body_part.right_foot"],
]);

const gkPassFlags = new Map<string, string>([
	["na", "event.v3.flag.global.na"],
	["kick-from-hand", "event.v3.flag.gk_pass.kick_from_hand"],
	["kick-from-ground", "event.v3.flag.gk_pass.kick_from_ground"],
	["throw", "event.v3.flag.gk_pass.throw"],
]);

const goalConcededTypeFlags = new Map<string, string>([
	["after-shot", "event.v3.flag.goal_conceded_type.after_shot"],
	["after-penalty", "event.v3.flag.goal_conceded_type.after_penalty"],
]);

const insidePaFlags = new Map<string, string>([
	["true", "event.v3.flag.global.true"],
	["false", "event.v3.flag.global.false"],
]);

const keyPassFlags = new Map<string, string>([
	["true", "event.v3.flag.global.true"],
	["false", "event.v3.flag.global.false"],
]);

const lengthFlags = new Map<string, string>([
	["short", "event.v3.flag.length.short"],
	["medium", "event.v3.flag.length.medium"],
	["long", "event.v3.flag.length.long"],
]);

const onTargetFlags = new Map<string, string>([
	["on", "event.v3.flag.on_target.on"],
	["off", "event.v3.flag.on_target.off"],
	["blocked", "event.v3.flag.on_target.blocked"],
]);

const restartShotFlags = new Map<string, string>([
	["no", "event.v3.flag.global.na"],
	["corner-kick", "event.v3.flag.restart.corner_kick"],
	["free-kick", "event.v3.flag.restart.free_kick"],
	["penalty", "event.v3.flag.restart.penalty"],
	["shootout", "event.v3.flag.restart.shootout"],
]);

const restartPassFlags = new Map<string, string>([
	["no", "event.v3.flag.global.na"],
	["corner-kick", "event.v3.flag.restart.corner_kick"],
	["free-kick", "event.v3.flag.restart.free_kick"],
	["goal-kick", "event.v3.flag.restart.goal_kick"],
	["throw-in", "event.v3.flag.restart.throw_in"],
]);

const saveTypeFlags = new Map<string, string>([
	["block", "event.v3.flag.save_type.block"],
	["catch", "event.v3.flag.save_type.catch"],
	["parry", "event.v3.flag.save_type.parry"],
]);

const situationFlags = new Map<string, string>([
	["play", "event.v3.flag.goal_type.play"],
	["penalty", "event.v3.flag.goal_type.penalty"],
]);

const shotGoalFlags = new Map<string, string>([
	["true", "event.v3.flag.global.true"],
	["false", "event.v3.flag.global.false"],
]);

const successFlags = new Map<string, string>([
	["true", "event.v3.flag.success.true"],
	["false", "event.v3.flag.success.false"],
]);

const tackleTypeFlags = new Map<string, string>([
	["standing", "event.v3.flag.tackle_type.standing"],
	["sliding", "event.v3.flag.tackle_type.sliding"],
]);

const thirdFlags = new Map<string, string>([
	["defensive", "event.v3.flag.third.defensive"],
	["middle", "event.v3.flag.third.middle"],
	["final", "event.v3.flag.third.final"],
]);

const underPressureFlags = new Map<string, string>([
	["true", "event.v3.flag.global.true"],
	["false", "event.v3.flag.global.false"],
]);

export enum EventFilterViewKey {
	EventId = "event.id",
}

const eventFilterViewFactory = (category: string, type: string, flags: { key: string, map: Map<string, string>, isUnique: boolean }[] = [], prefilter: EventViewPrefilter | undefined = undefined): EventFilterView => {
	const filter = {
		key: `event.${category}.${type}`,
		label: `event.v3.type.${type}`,
		type: "checkbox",
		value: type,
	} as EventFilterView;

	if (flags.length !== 0) {
		filter.nested = [];

		flags.forEach((flag) => {
			filter.nested?.push({
				key: `event.${category}.${type}.${flag.key}`,
				label: `event.v3.flag.${flag.key}`,
				type: flag.isUnique ? "singleFlags" : "multipleFlags",
				options: flag.map,
			} as EventFilterView);
		})
	}

	if (prefilter) {
		filter.prefilter = prefilter;
	}

	return filter;
}

export default [
	{
		key: "team.home",
		label: "Home team",
		type: "checkbox",
		value: "team.home",
		nested: [
			{
				key: "player.home",
				type: "checkboxList",
				value: "player.home",
				options: new Map<string, string>(),
			},
		],
	},
	{
		key: "team.away",
		label: "Away team",
		type: "checkbox",
		value: "team.away",
		nested: [
			{
				key: "player.away",
				type: "checkboxList",
				value: "player.away",
				options: new Map<string, string>(),
			},
		],
	},
	{
		key: "divider.1",
		type: "divider",
	},
	...[1, 2, 3, 4, 5].map((period: number) => ({
		key: `period.${period}`,
		label: `event.filter.period.${period}`,
		type: "checkbox",
		value: `${period}`,
	})),
	{
		key: "divider.2",
		type: "divider",
	},
	{
		key: "category.defensive",
		label: "event.filter.category.defensive",
		type: "checkbox",
		value: "defensive",
		nested: [
			eventFilterViewFactory("defensive", "block", [
				{ key: "block_type", map: blockTypeFlags, isUnique: false },
			], {
				type: ["block"],
			}),
			eventFilterViewFactory("defensive", "clearance", [
				{ key: "body_part", map: bodyPartFlags, isUnique: false },
				{ key: "under_pressure", map: underPressureFlags, isUnique: true }
			], {
				type: ["clearance"],
			}),
			eventFilterViewFactory("defensive", "own_goal", [], {
				type: ["own_goal"],
			}),
			eventFilterViewFactory("defensive", "card", [
				{ key: "card_type", map: cardTypeFlags, isUnique: true },
			], {
				type: ["card"],
			}),
			eventFilterViewFactory("defensive", "foul", [
				{ key: "under_pressure", map: underPressureFlags, isUnique: true },
			], {
				type: ["foul"],
				details: {
					foul_type: ["committed"],
				}
			}),
			eventFilterViewFactory("defensive", "interception", [
				{ key: "under_pressure", map: underPressureFlags, isUnique: true },
			], {
				type: ["interception"],
			}),
			eventFilterViewFactory("defensive", "recovery", [
				{ key: "body_part", map: bodyPartGoalKeeperFlags, isUnique: false },
			], {
				type: ["recovery"],
			}),
			eventFilterViewFactory("defensive", "tackle", [
				{ key: "success", map: successFlags, isUnique: true },
				{ key: "tackle_type", map: tackleTypeFlags, isUnique: true },
			], {
				type: ["tackle"],
			}),
			eventFilterViewFactory("defensive", "take_on_against", [
				{ key: "success", map: successFlags, isUnique: true },
			], {
				type: ["take_on_against"],
			}),
		],
	},
	{
		key: "category.goalkeeper",
		label: "event.filter.category.goalkeeper",
		type: "checkbox",
		value: "defensive",
		nested: [
			eventFilterViewFactory("goalkeeper", "catch_interception", [
				{ key: "success", map: successFlags, isUnique: true },
			], {
				type: ["catch_interception"],
			}),
			eventFilterViewFactory("goalkeeper", "punch", [
				{ key: "under_pressure", map: underPressureFlags, isUnique: true },
			], {
				type: ["punch"],
			}),
			eventFilterViewFactory("goalkeeper", "goal_conceded", [
				{ key: "goal_conceded_type", map: goalConcededTypeFlags, isUnique: true },
				{ key: "after_shot_inside_pa", map: afterShotInsidePaFlags, isUnique: true },
			], {
				type: ["goal_conceded"],
			}),
			eventFilterViewFactory("goalkeeper", "save", [
				{ key: "body_part", map: bodyPartGoalKeeperFlags, isUnique: false },
				{ key: "diving_save", map: divingSaveFlags, isUnique: true },
				{ key: "after_shot_inside_pa", map: afterShotInsidePaFlags, isUnique: true },
				{ key: "save_type", map: saveTypeFlags, isUnique: false },
			], {
				type: ["save"],
			}),
		],
	},
	{
		key: "category.offensive",
		label: "event.filter.category.offensive",
		type: "checkbox",
		value: "offensive",
		nested: [
			eventFilterViewFactory("offensive", "control_under_pressure", [
			], {
				type: ["control_under_pressure"],
			}),
			eventFilterViewFactory("offensive", "take_on", [
				{ key: "success", map: successFlags, isUnique: true },
				{ key: "third", map: thirdFlags, isUnique: false },
			], {
				type: ["take_on"],
			}),
			eventFilterViewFactory("offensive", "offside", [
			], {
				type: ["offside"],
			}),
			eventFilterViewFactory("offensive", "goal", [
				{ key: "situation", map: situationFlags, isUnique: true },
			], {
				type: ["goal"],
			}),
			eventFilterViewFactory("offensive", "foul_won", [
				{ key: "under_pressure", map: underPressureFlags, isUnique: true },
			], {
				type: ["foul"],
				details: {
					foul_type: ["won"],
				}
			}),
			eventFilterViewFactory("offensive", "shot", [
				{ key: "body_part", map: bodyPartFlags, isUnique: false },
				{ key: "under_pressure", map: underPressureFlags, isUnique: true },
				{ key: "goal", map: shotGoalFlags, isUnique: true },
				{ key: "restart", map: restartShotFlags, isUnique: false },
				{ key: "on_target", map: onTargetFlags, isUnique: false },
				{ key: "inside_pa", map: insidePaFlags, isUnique: true },
				// TODO what is first touch?
			], {
				type: ["shot"],
			}),
			eventFilterViewFactory("offensive", "technical_error", [
				{ key: "body_part", map: bodyPartGoalKeeperFlags, isUnique: false },
			], {
				type: ["technical_error"],
			}),
		],
	},
	{
		key: "category.distribution",
		label: "event.filter.category.distribution",
		type: "checkbox",
		value: "distribution",
		nested: [
			eventFilterViewFactory("distribution", "aerial_duel", [
				{ key: "success", map: successFlags, isUnique: true },
				{ key: "third", map: thirdFlags, isUnique: false },
				// {key: "assist", map: assistFlags, isUnique: true},
			], {
				type: ["aerial_duel"],
			}),
			eventFilterViewFactory("distribution", "pass", [
				{ key: "body_part", map: bodyPartFlags, isUnique: false },
				{ key: "success", map: successFlags, isUnique: true },
				{ key: "cross", map: crossFlags, isUnique: true },
				{ key: "assist", map: assistFlags, isUnique: true },
				{ key: "key_pass", map: keyPassFlags, isUnique: true },
				{ key: "restart", map: restartPassFlags, isUnique: false },
				{ key: "direction", map: directionFlags, isUnique: false },
				{ key: "length", map: lengthFlags, isUnique: false },
				{ key: "third", map: thirdFlags, isUnique: false },
				{ key: "gk_pass", map: gkPassFlags, isUnique: false },
				// TODO gk location?
			], {
				type: ["pass"],
			}),
			eventFilterViewFactory("distribution", "pass_received", [
				{ key: "under_pressure", map: underPressureFlags, isUnique: true },
			], {
				type: ["pass_received"],
			}),
		],
	},
	{
		key: "category.set_pieces",
		label: "event.filter.category.set_pieces",
		type: "checkbox",
		value: "set_pieces",
		nested: [
			eventFilterViewFactory("set_pieces", "corner", [
				{ key: "body_part", map: footFlags, isUnique: false },
				{
					key: "event_type", map: new Map<string, string>([
						["pass", "event.v3.type.pass"],
						["shot", "event.v3.type.shot"],
						["cross", "event.v3.type.cross"],
					]), isUnique: false
				},
				{
					key: "goal_contribution", map: new Map<string, string>([
						["na", "event.v3.flag.global.na"],
						["assist", "event.v3.flag.goal_contribution.assist"],
						["goal", "event.v3.flag.goal_contribution.goal"],
					]), isUnique: true
				},
			], {
				type: ["pass", "shot"],
				details: {
					restart: ["corner-kick"],
				}
			}),
			eventFilterViewFactory("set_pieces", "free_kick", [
				{ key: "body_part", map: footFlags, isUnique: false },
				{
					key: "event_type", map: new Map<string, string>([
						["pass", "event.v3.type.pass"],
						["shot", "event.v3.type.shot"],
						["cross", "event.v3.type.cross"],
					]), isUnique: false
				},
				{
					key: "goal_contribution", map: new Map<string, string>([
						["na", "event.v3.flag.global.na"],
						["assist", "event.v3.flag.goal_contribution.assist"],
						["goal", "event.v3.flag.goal_contribution.goal"],
					]), isUnique: true
				},
			], {
				details: {
					restart: ["free-kick"],
				}
			}),
			eventFilterViewFactory("set_pieces", "goal_kick", [
				{ key: "body_part", map: footFlags, isUnique: false },
				{
					key: "goal_contribution", map: new Map<string, string>([
						["na", "event.v3.flag.global.na"],
						["assist", "event.v3.flag.goal_contribution.assist"],
						["goal", "event.v3.flag.goal_contribution.goal"],
					]), isUnique: true
				},
			], {
				type: ["pass"],
				details: {
					restart: ["goal-kick"],
				}
			}),
			eventFilterViewFactory("set_pieces", "throw_in", [
				{
					key: "event_type", map: new Map<string, string>([
						["pass", "event.v3.type.pass"],
						["cross", "event.v3.type.cross"],
					]), isUnique: false
				},
				{
					key: "goal_contribution", map: new Map<string, string>([
						["na", "event.v3.flag.global.na"],
						["assist", "event.v3.flag.goal_contribution.assist"],
					]), isUnique: true
				},
			], {
				type: ["pass", "shot"],
				details: {
					restart: ["throw-in"],
				}
			}),
			eventFilterViewFactory("set_pieces", "penalty", [
				{ key: "body_part", map: footFlags, isUnique: false },
				{
					key: "goal_contribution", map: new Map<string, string>([
						["na", "event.v3.flag.global.na"],
						["assist", "event.v3.flag.goal_contribution.goal"],
					]), isUnique: true
				},
			], {
				type: ["pass", "shot"],
				details: {
					restart: ["penalty"],
				}
			}),
			eventFilterViewFactory("set_pieces", "penalty_shootout", [
				{ key: "body_part", map: footFlags, isUnique: false },
				{
					key: "goal_contribution", map: new Map<string, string>([
						["na", "event.v3.flag.global.na"],
						["assist", "event.v3.flag.goal_contribution.goal"],
					]), isUnique: true
				},
			], {
				type: ["pass", "shot"],
				details: {
					restart: ["shootout"],
				}
			}),
		],
	},
	{
		key: "divider.3",
		type: "divider",
	},
	{
		key: "highlight",
		label: "event.v3.type.highlight",
		type: "checkbox",
		value: "highlight",
		nested: [
			{
				key: "highlight.item",
				type: "checkboxList",
				value: "highlight.item",
				options: new Map<string, string>(),
			},
		],
		prefilter: {
			type: ["highlight"],
		},
	},
	{
		key: "hasComments",
		label: "event.filter.hasComments",
		type: "checkbox",
		value: "true",
		category: FilterCategory.HasComments
	},
	{
		key: EventFilterViewKey.EventId,
		value: EventFilterViewKey.EventId,
	}
] as EventFilterView[];
